<template>
  <div class="MailMiss">
    <div class="form1">
        <el-form :inline="true"> 
            <el-form-item class="as_btn">
                <el-button type="primary" @click="allretry()" :disabled="btnFlag">全部重发</el-button>
            </el-form-item>
            <el-form-item class="as_btn">
                <el-button type="danger" @click="alldelete()" :disabled="btnFlag">全部删除</el-button>
            </el-form-item>
        </el-form>
      </div>
      <el-table :data="emuOWebtList" stripe style="width: 100%" size="mini" border>
            <el-table-column prop="missemail" label="missemail" > </el-table-column>
            <el-table-column prop="sshqm" label="sshqm" > </el-table-column>
        <el-table-column label="操作" width="180">
            <template slot-scope="scope">
                <el-button size="mini" @click="retry(scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="dodelete(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'MailMiss',
  data(){
    return {
      emuOWebtList:[],
      btnFlag: false
    };
  },
  props: {
    msg: String
  },
  methods:{
    showAll(){
        let _this = this;
        this.$axios.post('/ssBaseS3Controller/getMailMiss.do',)
        .then(res => {
            _this.emuOWebtList = res.emuOWebtList;
            _this.btnFlag = false;
        }).catch(err => { _this.btnFlag = false;console.error(err); })
    },
    alldelete(){
      let _this = this;
      this.btnFlag = true;
      this.$axios.post('/ssBaseS3Controller/deleteALLMailMiss.do')
        .then(res => {
          // console.log(res);
          _this.$message({message: '删除成功', type: 'success', showClose: true, duration: 1000 });
          _this.showAll()
      }).catch(err => { _this.btnFlag = false;console.error(err); })
    },
    dodelete(row){
      let _this = this;
      this.btnFlag = true;
      this.$axios.post('/ssBaseS3Controller/deleteMailMiss.do',{...row,})
        .then(res => {
          // console.log(res);
          _this.$message({message: '删除成功', type: 'success', showClose: true, duration: 1000 });
          _this.showAll()
      }).catch(err => { _this.btnFlag = false;console.error(err); })
    },
    retry(row){
      let _this = this;
      this.btnFlag = true;
      this.$axios({
                    method: 'post',
                    url: '/clientController/sendEmail.do',
                    data: {
                        'email': (row.missemail + '').trim(),
                        'hqm': (row.sshqm + '').trim(),
      }})
        .then(res => {  //res是返回结果
            // console.log(res)
            this.$message({ message: '发送成功', type: 'success', showClose: true, duration: 1000 });
        }).catch(err => { _this.btnFlag = false;console.error(err); })
    },
    allretry(){
      this.$message({ message: '不支持的功能', type: 'error', showClose: true, duration: 1000 });
    }
  },
  created:function () {
    this.showAll();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
